const DEFAULT_ACTIVE_CLASS = "is-active";
const SPY_LOCK_MS = 900;

let bars = [];
let ticking = false;
let spyLockedUntil = 0;
let bound = false;
let livewireBound = false;

function collectBars() {
    bars = Array.from(document.querySelectorAll("[data-cat-bar]"));
}

function stickyTopOf(bar) {
    const value = parseFloat(window.getComputedStyle(bar).top);
    return Number.isNaN(value) ? 0 : value;
}

function trackOf(bar) {
    return bar.querySelector("[data-cat-track]") || bar;
}

function chipsOf(bar) {
    return Array.from(bar.querySelectorAll("[data-cat-chip]"));
}

function activeClassOf(bar) {
    return bar.dataset.catActive || DEFAULT_ACTIVE_CLASS;
}

function usesScrollSpy(bar) {
    return !!bar.querySelector("[data-cat-target]");
}

function centerChip(bar, chip, behavior) {
    const track = trackOf(bar);
    if (!track || !chip) return;
    if (track.scrollWidth <= track.clientWidth + 1) return;

    const trackRect = track.getBoundingClientRect();
    const chipRect = chip.getBoundingClientRect();
    const left =
        track.scrollLeft +
        (chipRect.left - trackRect.left) -
        (trackRect.width - chipRect.width) / 2;

    track.scrollTo({
        left: Math.max(0, left),
        behavior: behavior || "smooth",
    });
}

function setActive(bar, id, options) {
    const cls = activeClassOf(bar);
    const wanted = String(id);
    let active = null;

    chipsOf(bar).forEach((chip) => {
        const on = chip.dataset.catChip === wanted;
        chip.classList.toggle(cls, on);
        if (chip.hasAttribute("aria-pressed")) {
            chip.setAttribute("aria-pressed", on ? "true" : "false");
        }
        if (on) active = chip;
    });

    if (!active) return;
    if (!options || options.center !== false) {
        if (bar._catActiveChip !== active) centerChip(bar, active);
    }
    bar._catActiveChip = active;
}

function updateStuck(bar) {
    const anchorId = bar.dataset.catAnchor;

    if (anchorId) {
        const anchor = document.getElementById(anchorId);
        const passed = !!anchor && anchor.getBoundingClientRect().bottom <= 0;
        bar.classList.toggle("is-stuck", passed);
        return;
    }

    bar.classList.toggle(
        "is-stuck",
        bar.getBoundingClientRect().top <= stickyTopOf(bar) + 1
    );
}

function updateSpy(bar) {
    if (!usesScrollSpy(bar)) return;
    if (performance.now() < spyLockedUntil) return;

    const sections = Array.from(document.querySelectorAll("[data-cat-section]"));
    if (!sections.length) return;

    const line = stickyTopOf(bar) + bar.offsetHeight + 24;
    let current = sections[0].dataset.catSection;

    sections.forEach((section) => {
        if (section.getBoundingClientRect().top - line <= 0) {
            current = section.dataset.catSection;
        }
    });

    setActive(bar, current);
}

function tick() {
    ticking = false;
    bars.forEach((bar) => {
        updateStuck(bar);
        updateSpy(bar);
    });
}

function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(tick);
}

function onBrandClick(event) {
    const brand = event.target.closest("[data-cat-top]");
    if (!brand) return;

    event.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
}

function onChipClick(event) {
    const chip = event.target.closest("[data-cat-chip][data-cat-target]");
    if (!chip) return;

    const bar = chip.closest("[data-cat-bar]");
    const target = document.getElementById(chip.dataset.catTarget);
    if (!bar || !target) return;

    event.preventDefault();
    spyLockedUntil = performance.now() + SPY_LOCK_MS;

    const offset = stickyTopOf(bar) + bar.offsetHeight + 8;
    const top = window.scrollY + target.getBoundingClientRect().top - offset;

    window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
    setActive(bar, chip.dataset.catChip);
}

function refresh() {
    collectBars();
    if (!bars.length) return;

    bars.forEach((bar) => {
        bar._catActiveChip = null;
        updateStuck(bar);

        if (usesScrollSpy(bar)) {
            updateSpy(bar);
            return;
        }

        const cls = activeClassOf(bar);
        const active = chipsOf(bar).find((chip) => chip.classList.contains(cls));
        if (active) {
            bar._catActiveChip = active;
            centerChip(bar, active, "auto");
        }
    });
}

function bindLivewire() {
    if (livewireBound) return;
    if (!window.Livewire || typeof window.Livewire.hook !== "function") return;
    livewireBound = true;

    window.Livewire.hook("message.processed", () => {
        spyLockedUntil = 0;
        refresh();
    });
}

export default function initStickyCategories() {
    refresh();
    if (bound) return;
    bound = true;

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    document.addEventListener("click", onChipClick);
    document.addEventListener("click", onBrandClick);

    bindLivewire();
    document.addEventListener("livewire:load", bindLivewire);
}
